namespace Nbs.Xlr8PageTemplate.Theme {
  // all color string properties are expected to be valid html six digit hex color codes
  // ready to be directly set as the value of a style

  export const m50: keyof ColorSwatch = 'm50';
  export const m100: keyof ColorSwatch = 'm100';
  // export const m200: keyof ColorSwatch = 'm200';
  // export const m300: keyof ColorSwatch = 'm300';
  // export const m400: keyof ColorSwatch = 'm400';
  export const m500: keyof ColorSwatch = 'm500';
  // export const m600: keyof ColorSwatch = 'm600';
  // export const m700: keyof ColorSwatch = 'm700';
  // export const m800: keyof ColorSwatch = 'm800';
  export const m900: keyof ColorSwatch = 'm900';
  // export const a100: keyof ColorSwatch = 'a100';
  // export const a200: keyof ColorSwatch = 'a200';
  // export const a400: keyof ColorSwatch = 'a400';
  // export const a700: keyof ColorSwatch = 'a700';

  export const factsDefaultTheme: Theme = {
    logoUrl: 'https://d1h3z56lhcmivt.cloudfront.net/common/images/facts-white.png',
    logoBackgroundHexColor: '',
    faviconUrl: 'https://d1h3z56lhcmivt.cloudfront.net/nbs-template/2.2.456/favicon/facts/favicon-32x32.png',
    tenantDisplayName: 'FACTS',
    title: 'FACTS',
    header: {
      main: {
        m50: '#E8EEF8',
        m100: '#C4D5ED',
        m200: '#9EB8E1',
        m300: '#769CD5',
        m400: '#5987CC',
        m500: '#3C72C3',
        m600: '#366ABD',
        m700: '#2E5FB5',
        m800: '#2755AE',
        m900: '#1A42A0',
        a100: '#D8E2FF',
        a200: '#A5BCFF',
        a400: '#7296FF',
        a700: '#5883FF',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#FFFFFF',
        m600: '#FFFFFF',
        m700: '#FFFFFF',
        m800: '#FFFFFF',
        m900: '#FFFFFF',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    },
    primary: {
      main: {
        m50: '#E8EEF8',
        m100: '#C4D5ED',
        m200: '#9EB8E1',
        m300: '#769CD5',
        m400: '#5987CC',
        m500: '#3C72C3',
        m600: '#366ABD',
        m700: '#2E5FB5',
        m800: '#2755AE',
        m900: '#1A42A0',
        a100: '#D8E2FF',
        a200: '#A5BCFF',
        a400: '#7296FF',
        a700: '#5883FF',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#FFFFFF',
        m600: '#FFFFFF',
        m700: '#FFFFFF',
        m800: '#FFFFFF',
        m900: '#FFFFFF',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    },
    accent: {
      main: {
        m50: '#FFF3E5',
        m100: '#FEE2BF',
        m200: '#FDCE94',
        m300: '#FCBA69',
        m400: '#FCAC49',
        m500: '#FB9D29',
        m600: '#FA9524',
        m700: '#FA8B1E',
        m800: '#F98119',
        m900: '#F86F0F',
        a100: '#FFF6F1',
        a200: '#FFE6D7',
        a400: '#FFD6BE',
        a700: '#FFC6A4',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#000000',
        m600: '#000000',
        m700: '#000000',
        m800: '#000000',
        m900: '#000000',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    },
  };

  export const nccDefaultTheme: Theme = {
    logoUrl: 'https://d1h3z56lhcmivt.cloudfront.net/common/images/campus-commerce-white.png',
    logoBackgroundHexColor: '',
    faviconUrl: 'https://d1h3z56lhcmivt.cloudfront.net/nbs-template/2.2.456/favicon/nbs/favicon-32x32.png',
    tenantDisplayName: 'Nelnet',
    title: 'Nelnet',
    header: {
      main: {
        m50: '#EAF0E7',
        m100: '#CBD9C3',
        m200: '#A8C09A',
        m300: '#85A672',
        m400: '#6B9354',
        m500: '#518036',
        m600: '#4A7830',
        m700: '#406D29',
        m800: '#376322',
        m900: '#275016',
        a100: '#ABFF8C',
        a200: '#85FF59',
        a400: '#60FF26',
        a700: '#4EFF0C',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#FFFFFF',
        m600: '#FFFFFF',
        m700: '#FFFFFF',
        m800: '#FFFFFF',
        m900: '#FFFFFF',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    },
    primary: {
      main: {
        m50: '#EAF0E7',
        m100: '#CBD9C3',
        m200: '#A8C09A',
        m300: '#85A672',
        m400: '#6B9354',
        m500: '#518036',
        m600: '#4A7830',
        m700: '#406D29',
        m800: '#376322',
        m900: '#275016',
        a100: '#ABFF8C',
        a200: '#85FF59',
        a400: '#60FF26',
        a700: '#4EFF0C',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#FFFFFF',
        m600: '#FFFFFF',
        m700: '#FFFFFF',
        m800: '#FFFFFF',
        m900: '#FFFFFF',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    },
    accent: {
      main: {
        m50: '#EAF8F9',
        m100: '#CBEEF0',
        m200: '#A8E2E6',
        m300: '#86D6DD',
        m400: '#6CCED5',
        m500: '#52C5CE',
        m600: '#4BBFC9',
        m700: '#41B8C2',
        m800: '#38B0BC',
        m900: '#28A3B0',
        a100: '#BDF8FF',
        a200: '#A3F6FF',
        a400: '#8AF3FF',
        a700: '#70F1FF',
      },
      contrast: {
        m50: '#000000',
        m100: '#000000',
        m200: '#000000',
        m300: '#000000',
        m400: '#000000',
        m500: '#000000',
        m600: '#000000',
        m700: '#000000',
        m800: '#000000',
        m900: '#000000',
        a100: '#000000',
        a200: '#000000',
        a400: '#000000',
        a700: '#000000',
      }
    }
  };
}
